import {
  AppstoreOutline,
  CollectMoneyOutline,
  EditSOutline,
  RightOutline,
  UserOutline,
} from "antd-mobile-icons";

import CreateIcon from "@mui/icons-material/Create";
import HomeIcon from "@mui/icons-material/Home";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";

export default [
  {
    path: "/stu/app",
    key: "home",
    title: "Home",
    icon: AppstoreOutline,
    muiIcon: HomeIcon,

    module: "any",
    action: "any",
    exact: true,
  },
  { title: "divider" },
  {
    path: "/stu/app/my-attendance",
    key: "attendance",
    title: "Attendance",
    icon: CollectMoneyOutline,
    muiIcon: NewspaperIcon,
    module: "any",
    action: "any",
    exact: true,
  },
  {
    path: "/stu/app/my-fees",
    key: "my_fees",
    title: "My Fees",
    icon: EditSOutline,
    muiIcon: CreateIcon,
    module: "stu_mob_allow_fees",
    action: "action_list",
    exact: true,
  },
  {
    path: "/stu/app/exam-fees",
    key: "exam_fees",
    title: "Exam Fees",
    icon: EditSOutline,
    muiIcon: CreateIcon,
    module: "stu_mob_allow_exam_fees",
    action: "action_create",
    exact: true,
  },
  {
    path: "/stu/app/my-profile",
    key: "my_profile",
    title: "Profile",
    icon: UserOutline,
    muiIcon: PersonOutlineOutlinedIcon,
    module: "any",
    action: "any",
    exact: true,
  },
  { title: "divider" },
  {
    path: "/lock_screen",
    key: "lock_screen",
    title: "Logout",
    icon: RightOutline,
    muiIcon: LogoutOutlinedIcon,
    module: "any",
    action: "any",
    onclick: "logout",
    exact: true,
  },
];
